import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
import multipart from "../user/mutlipart";
const editCompany = (email, name, company_name,address, country,state,city,zip_code,phone_number,currency,locale,my_id,user,image,stripeaccount) => {
  return axios.post(API + "company/edit-profile/", {
    email,
    name,
    company_name,
    address,
    country,
    state,
    city,
    zip_code,
    phone_number,
    currency,
    locale,
    my_id,
    user,
    image,
    stripeaccount
  },
  
  
  {headers: authHeader() });
};

const editCompanyProfile = (email, name, company_name,address, country,state,city,zip_code,phone_number,currency,locale,my_id,user,grant_login_access,lender_id) => {
  return axios.post(API + "company/edit-profile/", {
    email,
    name,
    company_name,
    address,
    country,
    state,
    city,
    zip_code,
    phone_number,
    currency,
    locale,
    my_id,
    user,
    grant_login_access,
    lender_id
  },
  
  
  {headers: authHeader() });
};

const editStirpeCompany = (stripeaccount) => {
  return axios.post(API + "company/edit-profile/", {
    stripeaccount
  },
  
  
  {headers: authHeader() });
};


const editImage = (image) => {
  return axios.post(API + "company/edit-image/", {
    image
  },
  
  
  {headers: multipart() });
}
  const editCompanystripeaccount = (stripeaccount,stripepaymentstatus) => {
  return axios.post(API + "company/edit-companystripeaccountid/", {
    stripeaccount,
    stripepaymentstatus
  },
  
  
  {headers: authHeader() });
}
const editplan = (plan) => {
  return axios.post(API + "company/edit-plan/", {
    plan
  },  
  {headers: authHeader() });
}
const excelfileparty = (excel_file) => {
  return axios.post(API + "company/party-import/", {
    excel_file,
  },
  
  
  {headers: multipart() });
}
const excelfilepartyaddress = (excel_file) => {
  return axios.post(API + "company/partyaddress-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}
const excelfilepartycontact = (excel_file) => {
  return axios.post(API + "company/partycontact-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}
const excelfilecontract = (excel_file) => {
  return axios.post(API + "company/contracts-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}
const excelfilecontractpaymentschedule = (excel_file) => {
  return axios.post(API + "company/contractpaymentschedule-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}
const excelfilecontractassets = (excel_file) => {
  return axios.post(API + "company/contractassets-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}

const excelfileinvoice = (excel_file) => {
  return axios.post(API + "company/invoice-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}

const excelfilereceipt = (excel_file) => {
  return axios.post(API + "company/receipt-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}

const excelfiletaxrate = (excel_file) => {
  return axios.post(API + "company/taxrates-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}
const excelfileInventory = (excel_file) => {
  return axios.post(API + "company/inventory-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}

const excelfileachaccounts = (excel_file) => {
  return axios.post(API + "company/achaccounts-import/", {
    excel_file
  },
  
  
  {headers: multipart() });
}

const excelfileAdditionalparties = (excel_file) => {
  return axios.post(API + "company/additionalparties-import/", {
    excel_file
  },


  {headers: multipart() });
}

const csvBulkImport = (excel_file) => {
  return axios.post(API + "company/csv-bulk-import/", {
    excel_file
  },
  {headers: multipart() });
}


const EditCompanyService = {
    editCompany,
    editImage,
    excelfileparty,
    excelfilepartyaddress,
    excelfilepartycontact,
    excelfilecontract,
    excelfilecontractpaymentschedule,
    excelfilecontractassets,
    editplan,
    excelfileinvoice,
    excelfilereceipt,
    editCompanystripeaccount,
    excelfiletaxrate,
    editStirpeCompany,
    editCompanyProfile,
    excelfileInventory,
    excelfileachaccounts,
    excelfileAdditionalparties,
    csvBulkImport
  };
  export default EditCompanyService;